document.addEventListener("DOMContentLoaded", function () {
    // Selecciona todos los popups del tema
    const popups = document.querySelectorAll(".popup-main");

    popups.forEach((popup) => {
        // Evitar abrir si ya está abierto (solo por seguridad)
        if (!popup.classList.contains("popup-open")) {
            popup.classList.add("popup-open");

            // Mostrar overlay si está activado
            const overlay = document.querySelector(".popup-overlay");
            if (overlay && popup.dataset.overlay === "true") {
                overlay.style.display = "block";
            }
        }

        // Manejar botón de cerrar
        const closeButton = popup.querySelector(".popup-close");
        if (closeButton) {
            closeButton.addEventListener("click", () => {
                popup.classList.remove("popup-open");
                if (overlay) overlay.style.display = "none";
            });
        }

        // Manejar submit del newsletter (sin cookies)
        const form = popup.querySelector("form.newsletter-form");
        if (form) {
            form.addEventListener("submit", function (e) {
                // Aquí simplemente deja que se envíe
                // Puedes agregar animaciones de "gracias" si quieres
            });
        }
    });
});
